import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { AssignmentRow } from "./AssignmentRow";
import { MotivationCard } from "./MotivationCard";
import { ProgressPanel } from "./ProgressPanel";

export const PlayerEvaluations = ({ clientId }) => {
  const [rows, setRows] = useState(null);
  const [prog, setProg] = useState(null);
  const [mot, setMot] = useState(null);
  const load = useCallback(() => {
    api.get(`/admin/test-assignments?client_id=${clientId}`).then((r) => setRows(r.data)).catch((e) => toast.error(formatErr(e)));
    api.get(`/admin/test-progress/${clientId}`).then((r) => setProg(r.data)).catch(() => setProg([]));
    api.get(`/admin/test-motivation/${clientId}`).then((r) => setMot(r.data)).catch(() => {});
  }, [clientId]);
  useEffect(() => { load(); }, [load]);
  if (!rows) return <div style={{ color: "#a3a3a3" }}>Cargando…</div>;
  const active = rows.filter((a) => a.status === "active");
  const retired = rows.filter((a) => a.status !== "active");
  return (
    <div data-testid="player-evaluations">
      <MotivationCard m={mot} admin />
      <div className="qv-card-app" style={{ padding: 16, marginBottom: 14 }} data-testid="pe-assignments">
        <div style={{ fontWeight: 800 }}>Evaluaciones asignadas</div>
        <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 6 }}>Abre vídeos, comenta (visible o interno), valida, corrige con historial, aplaza la fecha o solicita una nueva ejecución.</div>
        {!active.length && <div style={{ fontSize: 13, color: "#a3a3a3" }} data-testid="pe-empty">No tiene tests activos. Asígnalos desde Biblioteca de tests.</div>}
        {active.map((a) => <AssignmentRow key={a.id} a={a} reload={load} manage />)}
        {retired.length > 0 && <><div style={{ fontSize: 12, color: "#737373", marginTop: 12 }}>Retirados (historial)</div>{retired.map((a) => <AssignmentRow key={a.id} a={a} reload={load} manage />)}</>}
      </div>
      <div style={{ fontWeight: 800, margin: "4px 0 10px" }}>Evolución</div>
      {prog ? <ProgressPanel items={prog} admin reload={load} /> : null}
    </div>
  );
};
